// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skeleton-loader-group[data-v-48c8592c]  .pu-skeleton{border-radius:1px}.skeleton-loader-group[data-v-48c8592c]  .ico.chart{position:absolute;top:auto;bottom:0}@media screen and (min-width:768px){.skeleton-loader-group[data-v-48c8592c]  .ico.chart{transform:scaleX(2.5);transform-origin:top left}}", ""]);
// Exports
module.exports = exports;
